import { useMemo } from 'react';
import * as yup from 'yup';
import { FORM_LINE_TYPES } from 'src/components/ui/FormLine/constants';
import FieldRepeaterCContacts from 'src/components/ui/FieldRepeater/connectors/FieldRepeaterCContacts';

export const useFormPersonNumber = (params = {}) => {
	const { values } = params;

	const defaultValues = useMemo(() => {
		return {
			name: values?.target?.firstName || '',
			secondName: values?.target?.lastName || '',
			thirdName: values?.target?.middleName || '',
			contacts: [{ type: null, text: '' }],
			job: values?.target?.position || null,
			decisionMaker: values?.target?.responsiblePerson ? '1' : '0',
			comment: values?.target?.comment || '',
			...values,
		};
	}, [values]);

	const shape = useMemo(() => {
		return {
			groups: [
				{
					id: 1,
					lines: [
						{
							id: 1,
							field: {
								type: FORM_LINE_TYPES.textfield,
								connected: true,
								params: {
									name: 'secondName',
									label: 'Фамилия',
								},
							},
						},
						{
							id: 2,
							field: {
								type: FORM_LINE_TYPES.textfield,
								connected: true,
								params: {
									name: 'name',
									label: 'Имя',
								},
							},
						},
						{
							id: 3,
							field: {
								type: FORM_LINE_TYPES.textfield,
								connected: true,
								params: {
									name: 'thirdName',
									label: 'Отчество',
								},
							},
						},
						{
							id: 4,
							repeater: {
								Component: FieldRepeaterCContacts,
								label: 'Телефон',
								name: 'contacts',
							},
						},
						{
							id: 5,
							field: {
								type: FORM_LINE_TYPES.autocomplete,
								connected: true,
								params: {
									name: 'job',
									label: 'Должность',
									options: [
										{ label: 'Уборщик', value: 1 },
										{ label: 'Директор', value: 2 },
										{ label: 'Менеджер', value: 3 },
									],
								},
							},
						},
						{
							id: 7,
							field: {
								type: FORM_LINE_TYPES.radio,
								connected: true,
								params: {
									label: 'Лицо, принимающее решения',
									name: 'decisionMaker',
									options: [
										{ label: 'Да', value: '1' },
										{ label: 'Нет', value: '0' },
									],
									group: {
										row: true,
									},
								},
							},
						},
						{
							id: 6,
							field: {
								type: FORM_LINE_TYPES.textfield,
								connected: true,
								params: {
									name: 'comment',
									label: 'Комментарий',
									multiline: true,
									minRows: 4,
								},
							},
						},
					],
				},
			],
		};
	}, []);

	const validationSchema = yup.object().shape({
		name: yup.string().required('Имя обязательно'),
		secondName: yup.string().required('Укажите фамилию'),
		job: yup.object().required('Укажите должность'),
		contacts: yup
			.array()
			.min(1, 'Укажите хотя бы один контакт')
			.of(
				yup.object().shape({
					text: yup
						.string()
						.required('Укажите телефон')
						.matches(/^((?!_).)*$/g, 'Укажите телефон полностью'),
					type: yup.object().nullable(),
				}),
			),
	});

	return { shape, initialValues: defaultValues, validationSchema };
};
